// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_questions.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CreateRfiQuestionRequest, CreateRfiQuestionResponse, ExtractRfiQuestionsRequest, ExtractRfiQuestionsResponse, ListRfiQuestionsRequest, ListRfiQuestionsResponse, ReviewRfiQuestionRequest, ReviewRfiQuestionResponse, SetRfiQuestionMappingRequest, SetRfiQuestionMappingResponse } from "./rfi_questions_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * All methods authorize the RFI through Cerbos before fetching question/source data.
 * Tenant and actor always come from the authenticated gateway principal.
 *
 * @generated from service mono.projectdata.v1.RfiQuestionsService
 */ export const RfiQuestionsService = {
    typeName: "mono.projectdata.v1.RfiQuestionsService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.RfiQuestionsService.ListRfiQuestions
     */ listRfiQuestions: {
            name: "ListRfiQuestions",
            I: ListRfiQuestionsRequest,
            O: ListRfiQuestionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiQuestionsService.CreateRfiQuestion
     */ createRfiQuestion: {
            name: "CreateRfiQuestion",
            I: CreateRfiQuestionRequest,
            O: CreateRfiQuestionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiQuestionsService.SetRfiQuestionMapping
     */ setRfiQuestionMapping: {
            name: "SetRfiQuestionMapping",
            I: SetRfiQuestionMappingRequest,
            O: SetRfiQuestionMappingResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiQuestionsService.ReviewRfiQuestion
     */ reviewRfiQuestion: {
            name: "ReviewRfiQuestion",
            I: ReviewRfiQuestionRequest,
            O: ReviewRfiQuestionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiQuestionsService.ExtractRfiQuestions
     */ extractRfiQuestions: {
            name: "ExtractRfiQuestions",
            I: ExtractRfiQuestionsRequest,
            O: ExtractRfiQuestionsResponse,
            kind: MethodKind.Unary
        }
    }
};
